import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function BraceletsIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M2.47987 23.4461L8.55391 29.5202C10.5313 31.4975 16.8276 28.4067 22.6171 22.6171M2.47987 23.4461C3.41726 24.3835 5.32738 24.1814 7.69385 23.0922M2.47987 23.4461C0.714699 21.6809 2.98842 16.4746 7.61451 11.259L12.4742 16.1187C10.3053 18.5629 8.65439 21.0052 7.69385 23.0922M22.6171 22.6171C28.407 16.8273 31.4975 10.5314 29.5202 8.55405L23.446 2.47994M22.6171 22.6171H16.543V16.5431M22.6171 22.6171V16.5431H16.543M7.69385 23.0922C10.3158 21.8842 13.4995 19.5866 16.543 16.5431M23.446 2.47994C21.6809 0.714825 16.4746 2.98776 11.2589 7.61454L16.1182 12.4739C18.5624 10.3058 21.0046 8.65404 23.0922 7.69314M23.446 2.47994C24.3835 3.41739 24.1814 5.32749 23.0922 7.69314M16.543 16.5431C19.5869 13.4992 21.8846 10.3155 23.0922 7.69314M12.4132 26.5722V24.8148M25.254 13.7314V11.974"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </BaseIcon>
  );
}
